
import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";
import router from "@/router";
import { AUTHENTICATION__API } from "@/_helpers/urls";
import { AUTHENTICATION__MUTATIONS } from "../mutation-types";
import { AUTHENTICATION__ACTIONS } from "../action-types";
import { startTrackingInactivity } from "@/utils/inactivityTracker";
import { startSessionMonitor } from "@/utils/sessionMonitor";

// State
const state = {
  token: null,
  viewPassword: false,
  logOutTime: 0,
  userId: null,
  alreadyLoggedIn: false,
  existingDevice: null
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [AUTHENTICATION__MUTATIONS.TOKEN](state, data) {
    state.token = data?.token?.token;
    state.userId = data?.userId;
    state.existingDevice = data?.existingDevice;
    state.alreadyLoggedIn = data?.alreadyLoggedIn;
    state.logOutTime = data?.logOutTime;

    localStorage.setItem("token", data?.token?.token);
    localStorage.setItem("userId", data?.userId);
    localStorage.setItem("loginTime", new Date().getTime());
  },

  [AUTHENTICATION__MUTATIONS.REMOVE_TOKEN](state) {
    state.token = null;
    state.userId = null;
    state.existingDevice = null;
    state.alreadyLoggedIn = false;
    state.logOutTime = 0;
    // Clear from localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    localStorage.removeItem("loginTime");
  },
};

// Actions
const actions = {
  async [AUTHENTICATION__ACTIONS.LOGIN]({ commit, state, dispatch }, parameter) {
    try {
      const response = await HTTP().post(AUTHENTICATION__API.AUTHLOGIN, {
        email: parameter.email,
        password: parameter.password,
        forceLogout: parameter.forceLogout || false
      });

      commit(AUTHENTICATION__MUTATIONS.TOKEN, response.data);
      // // Start session monitoring
      startSessionMonitor();

      if (!response.data.alreadyLoggedIn) {
        if (state.logOutTime > 0) {
          startTrackingInactivity(this);
        }
        await dispatch('admins/GETADMIN', null, { root: true });
        toast.success(response.data?.message);
        router.push("/dashboard");
      }
    } catch (error) {
      toast.error("Login Failed");
    }
  },

  async [AUTHENTICATION__ACTIONS.FORCELOGOUT]({ state, commit }) {
    try {
      if (!state.userId) {
        return { success: false, message: "No user ID found" };
      }

      const response = await HTTP().post(AUTHENTICATION__API.FORCELOGOUT, {
        userId: state.userId
      });

      // Important: Always clear token after force logout
      commit(AUTHENTICATION__MUTATIONS.REMOVE_TOKEN);

      if (response.status === 200) {
        return { success: true };
      } else {
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      // Even on error, attempt to remove token
      commit(AUTHENTICATION__MUTATIONS.REMOVE_TOKEN);
      console.error("Force logout error:", error);
      return { success: false, message: "Server error" };
    }
  },

  // In your authentication store
  async [AUTHENTICATION__ACTIONS.LOGOUT]({ state, commit }) {
    try {
      await HTTP().post(AUTHENTICATION__API.AUTHLOGOUT);
    } catch (error) {
      console.error(error);
    } finally {
      commit(AUTHENTICATION__MUTATIONS.REMOVE_TOKEN);
      toast.success("You are logged out");
      router.push("/");
    }
  },
  // Add this action to your authentication store
  async [AUTHENTICATION__ACTIONS.INITIALIZE_AUTH]({ commit }) {
    try {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");

      if (!token || !userId) {
        return false;
      }

      // Validate the token with a backend request if possible
      try {
        const response = await HTTP().get(`${AUTHENTICATION__API.CHECK_SESSION}/${userId}`);
        if (!response.data.valid) {
          // Token is invalid, clear it
          localStorage.removeItem("token");
          localStorage.removeItem("userId");
          return false;
        }
      } catch (error) {
        console.error("Error validating token:", error);
        // Clear invalid tokens
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        return false;
      }

      // Restore the authentication state
      commit(AUTHENTICATION__MUTATIONS.TOKEN, {
        token: { token },
        userId,
        // logOutTime: parseInt(localStorage.getItem("logOutTime")) || 0
      });

      return true;
    } catch (error) {
      console.error("Error initializing auth:", error);
      return false;
    }
  }
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};